module.exports = __webpack_public_path__ + "img/solicitud-recibida.6d5beffe.svg";